import { Stack, Alert } from '@mantine/core';
import { IconAlertCircle } from '@tabler/icons-react';

interface FileErrorDisplayProps {
  userError: string | null;
  partnerError: string | null;
  setUserFileError: (error: string | null) => void;
  setPartnerFileError: (error: string | null) => void;
  // opened and onClose are no longer needed
}

export function FileErrorDisplay({
  userError,
  partnerError,
  setUserFileError,
  setPartnerFileError,
}: FileErrorDisplayProps) {
  if (!userError && !partnerError) {
    return null;
  }

  return (
    <Stack mt="md" mb="md">
      {userError && (
        <Alert
          title="File processing error (Your file)"
          color="red"
          icon={<IconAlertCircle size={16} />}
          withCloseButton
          onClose={() => {
            setUserFileError(null);
          }}
        >
          {userError}
        </Alert>
      )}
      {partnerError && (
        <Alert
          title="File processing error (Partner's file)"
          color="red"
          icon={<IconAlertCircle size={16} />}
          withCloseButton
          onClose={() => {
            setPartnerFileError(null);
          }}
          mt={userError ? 'sm' : undefined} // Add margin top if userError is also shown
        >
          {partnerError}
        </Alert>
      )}
    </Stack>
  );
}
